import { API_LIST_STATUSES } from '../constants';

export default function isApiListFilter(filter) {
  return API_LIST_STATUSES.includes(filter);
}
